import React, { useEffect } from "react";
import ReactFamilyTree from "react-family-tree";
import nodes from "./components/small.json";
import PinchZoomPan from "./components/PinchZoomPan";
import FamilyNode from "./components/FamilyNode";
import styles from "./familyTree.scss";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { Endpoint, Status } from "../../apis/apiConstants";
import SessionDetails from "../../helpers/sessionDetails";
import AjaxHelper from "../../apis/apiRequest";
import { startLoading, stopLoading } from "../../actions/loadingAction";
import { useSearchParams } from "react-router-dom";
import { isFieldEmpty, isObjectEmpty } from "../../helpers/appFieldValidation";
import { errorSnackbar } from "../../actions/snackbarActions";

const WIDTH = 240;
const HEIGHT = 280;

export default function FamilyTree() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [myID, setMyID] = React.useState(null);
  const [rootId, setRootId] = React.useState(myID);
  const [familyUsers, setFamilyUsers] = React.useState([]);
  const [urlParams] = useSearchParams();

  //const onResetClick = React.useCallback(() => setRootId(myID), []);

  useEffect(() => {
    const user = SessionDetails.getCurrentUser();
    if (!isObjectEmpty(user)) {
      getFamilyTree(user.family);
    } else {
      const familyId = urlParams.get("family");
      getFamilyTree(familyId);
    }
  }, []);

  const getFamilyTree = (id) => {
    dispatch(startLoading);
    const userToken = SessionDetails.getAccessToken();

    const token = isFieldEmpty(userToken) ? urlParams.get("token") : userToken;
    AjaxHelper.getAxiosInstanceToken(token)
      .get(Endpoint.FAMILY_TREE + "/" + id)
      .then((response) => {
        dispatch(stopLoading);
        if (response.data.status === Status.API_SUCCESS) {
          setFamilyUsers(response.data.data);
          const user = SessionDetails.getCurrentUser();

          if (user) {
            setMyID(user.id);
            setRootId(user.id);
          } else {
            const userId = urlParams.get("user_code");
            setMyID(userId);
            setRootId(userId);
          }
        } else {
          dispatch(errorSnackbar("Unable to fetch family."));
        }
      })
      .catch((error) => {
        dispatch(stopLoading);
        console.log(error);
        dispatch(errorSnackbar("Unable to fetch family."));
      });
  };

  return (
    <div className={styles.root}>
      {myID ? (
        <PinchZoomPan
          captureWheel
          min={0.4}
          max={2.5}
          className={styles.wrapper}
          key={rootId}
        >
          <ReactFamilyTree
            nodes={familyUsers}
            rootId={rootId}
            width={WIDTH}
            height={HEIGHT}
            canvasClassName={{ backgroundColor: "white" }}
            renderNode={(node) => (
              <FamilyNode
                key={node.id}
                isCurrentUser={node.id === myID}
                node={node}
                onSubClick={setRootId}
                isRoot={node.id === rootId}
                style={{
                  width: WIDTH,
                  height: HEIGHT,
                  transform: `translate(${node.left * (WIDTH / 2)}px, ${
                    node.top * (HEIGHT / 2)
                  }px)`,
                }}
              />
            )}
          />
        </PinchZoomPan>
      ) : null}
    </div>
  );
}